import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/lib/brand";
import Reveal from "./Reveal";

const MotionLink = motion(Link);

const SectionTitle = ({ overline, title }) => (
  <div className="text-center mb-14">
    <p className="text-xs uppercase tracking-luxe text-gold mb-3">{overline}</p>
    <h2 className="font-serif text-4xl sm:text-5xl text-choco flex items-center justify-center gap-4">
      <span className="h-px w-8 bg-beige hidden sm:inline-block" />
      {title}
      <span className="h-px w-8 bg-beige hidden sm:inline-block" />
    </h2>
  </div>
);

const Categories = () => {
  return (
    <section id="categorias" className="bg-cream py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-5">
        <Reveal><SectionTitle overline="Explore" title="Nossas Categorias" /></Reveal>
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {CATEGORIES.map((c, i) => (
            <Reveal key={c.key} delay={i * 0.12}>
              <MotionLink to={`/categoria/${c.key}`}
                data-testid={`category-${c.key}`}
                whileHover={{ y: -8 }} transition={{ type: "spring", stiffness: 300 }}
                className="group block relative rounded-3xl overflow-hidden h-[440px] shadow-md">
                <img src={c.image} alt={c.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-choco via-choco/40 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-7 text-cream">
                  <h3 className="font-serif text-3xl mb-2">{c.title}</h3>
                  <p className="text-sm text-cream/75 max-w-xs mb-4 leading-relaxed">{c.desc}</p>
                  <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-gold">
                    Ver mais <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                  </span>
                </div>
              </MotionLink>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
export { SectionTitle };
